import { format, isValid, parse } from 'date-fns';

const kebabDate = 'yyyy-MM-dd';
const slashDateFormat = 'MM/dd/yyyy';

function isDateInFormat(dateString: string, format: string): boolean {
  try {
    const parsedDate = parse(dateString, format, new Date());
    return isValid(parsedDate);
  } catch (e) {
    return false;
  }
}

export const convertKebabToSlash = (dateString: string) => {
  try {
    const cleanedDate = dateString.split('T')[0];
    if (isDateInFormat(cleanedDate, slashDateFormat)) {
      return cleanedDate;
    }
    const parsedDate = parse(cleanedDate, kebabDate, new Date());

    if (!isValid(parsedDate)) {
      console.warn(
        `Invalid date string.\n${dateString} does not appear to be in yyyy-MM-dd format or MM/dd/yyyy format`
      );
      return '';
    }

    return format(parsedDate, 'MM/dd/yyyy');
  } catch (e) {
    return '';
  }
};

export const convertSlashToKebab = (dateString: string) => {
  try {
    if (isDateInFormat(dateString, kebabDate)) {
      return dateString;
    }
    const parsedDate = parse(dateString, slashDateFormat, new Date());
    if (!isValid(parsedDate)) {
      console.warn(
        `Invalid date string.\n${dateString} does not appear to be in MM/dd/yyyy format or yyyy-MM-dd format`
      );
      return '';
    }
    return format(parsedDate, kebabDate);
  } catch (e) {
    return '';
  }
};
